/* import __COLOCATED_TEMPLATE__ from './output-current-max.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();